module.exports = __webpack_public_path__ + "static/media/gfronsdal.deaaf529.jpg";